const appColors = {
  primary: '#735092',
  white: '#FFF',
  blue: '#3CA79A',
  darkBlue: '#3A4594',
  black: '#000',
  gray: '#d5d5d5',
  green: '#3CA79A',
};

export { appColors };
